const PLACEHOLDER_SYMBOL = '•';

/**
 * Нормализует номер карты:
 *
 * "1234 5678 9012 3456" -> "1234567890123456"
 *
 * @param {string} cardNumber Номер карты.
 * @returns {string} Номер карты без пробелов.
 */
export const normalizeCardNumber = (cardNumber: string) => {
  return cardNumber.replace(/\s/g, '');
};

/**
 * Извлекает 8-ми значный БИН нормеризованного номера карты.
 *
 * "1234567800000000" -> "12345678"
 *
 * @param {string} cardNumber Нормализованный номер карты.
 * @returns {string | null} Первые 8 цифр или null.
 */
export const extractBin8 = (cardNumber: string) => {
  return /^\d{8}/.exec(cardNumber)?.[0] ?? null;
};

/**
 * Извлекает последние 4 символа нормеризованного номера карты.
 *
 * "0000000000003456" -> "3456"
 *
 * @param {string} cardNumber Нормализованный номер карты.
 * @returns {string | null} Последние 4 цифры или null.
 */
export const extractLast4 = (cardNumber: string) => {
  return /\d{4}$/.exec(cardNumber)?.[0] ?? null;
};

/**
 * Извлекает и маскирует последние 4 символа нормеризованного номера карты.
 *
 * "0000000000003456" -> "•• 3456"
 *
 * @param {string} cardNumber Нормализованный номер карты.
 * @returns {string} Маскированные последние 4 цифры.
 */
export const extractMaskedLast4 = (cardNumber: string) => {
  // eslint-disable-next-line no-irregular-whitespace
  return `${PLACEHOLDER_SYMBOL}${PLACEHOLDER_SYMBOL} ${extractLast4(cardNumber)}`;
};

/**
 * Проверяет, что номер карты представляет из себя маскированные последние 4 символа.
 *
 * "•• 3456" -> true
 *
 * @param {string} cardNumber Номер карты.
 * @returns {boolean} true, если номер является маскированным last4.
 */
export const checkMaskedLast4 = (cardNumber: string) => {
  // eslint-disable-next-line no-irregular-whitespace
  return new RegExp(`^[${PLACEHOLDER_SYMBOL}]{2}\\s*\\d{4}$`).test(cardNumber);
};
